import fr from './fr/index.js'
import en from './en/index.js'
import ar from './ar/index.js'

export default {
  en,
  fr,
  ar
}
